import { SolicitationContactModalControlType } from 'components/SolicitationContactModal/schema'
import { InputHTMLAttributes } from 'react'

// Valores não podem ser alterados, pois acompanham o RDStation
const SEGMENT_OPTIONS = [
  'CEO / Proprietário(a)',
  'Gerente / Liderança de Tecnologia e Infraestrutura',
  'Analista de Tecnologia e Infraestrutura',
  'Liderança de Segurança da Informação',
  'Analista de Segurança da Informação',
  'Jurídico',
  'Liderança de Financeiro e RH',
  'Analista de Negócios de Vendas',
  'Analista de Financeiro e RH',
  'Liderança de Marketing',
  'Analista de Marketing',
  'DPO da empresa',
  'Outros',
]

// Valores não podem ser alterados, pois acompanham o RDStation
const EMPLOYEES_OPTIONS = [
  'Não tenho funcionário',
  'De 1 a 15',
  'De 16 a 50',
  'Acima de 50',
]

const SOLICITATION_CONTACT_CONTROL_ITEMS: SolicitationContactControlItems[] = [
  { name: 'name', label: 'Nome' },
  { name: 'email', label: 'E-mail corporativo', type: 'email' },
  { name: 'phone', label: 'Telefone', type: 'phone' },
  { name: 'companyName', label: 'Nome da empresa' },
  { name: 'document', label: 'CPF ou CNPJ' },
]

type SolicitationContactControlItems = {
  name: SolicitationContactModalControlType
  label: string
  type?: InputHTMLAttributes<unknown>['type']
}

export default {
  SOLICITATION_CONTACT_CONTROL_ITEMS,
  SEGMENT_OPTIONS,
  EMPLOYEES_OPTIONS,
}
